export const DefaultShowCamera = false;
